<form [formGroup]="formGroup">
  <fieldset class="wbce">
    <mat-select formControlName="accountStrategy">
      @for (option of accountStrategiesOptions; track option) {
        <mat-option [value]="option.value">
          {{ option.label }}
        </mat-option>
      }
    </mat-select>
  </fieldset>
  @if (
    currentAccountStrategy ===
    accountStrategies.USE_EXISTING_ACCOUNT
    ) {
    <mat-hint
      >
      If using an existing account, make sure is is properly
      configured so that your main account can assume its role.
    </mat-hint>
  }
  <fieldset class="wbce">
    <legend>
      {{
      currentAccountStrategy ===
      accountStrategies.USE_EXISTING_ACCOUNT
      ? 'Account ID'
      : 'Email for the new account'
      }}
    </legend>
    <span style="width: 100%">
      <input
        formControlName="accountInfo"
                [placeholder]="
                    'Ex. : ' +
                    (currentAccountStrategy ===
                    accountStrategies.USE_EXISTING_ACCOUNT
                        ? '112233445566'
                        : 'john.doe@webcapsule.io')
                "
        />
    </span>
  </fieldset>
  @if (
    formGroup.controls.accountInfo.invalid &&
    (formGroup.controls.accountInfo.dirty ||
    formGroup.controls.accountInfo.touched)
    ) {
    @if (formGroup.controls.accountInfo.errors?.required) {
      <mat-error>
        {{
        currentAccountStrategy ===
        accountStrategies.USE_EXISTING_ACCOUNT
        ? 'Account ID'
        : 'Email'
        }}
        is required
      </mat-error>
    }
    @if (formGroup.controls.accountInfo.errors?.email) {
      <mat-error>
        Invalid email address
      </mat-error>
    }
    @if (formGroup.controls.accountInfo.errors?.pattern) {
      <mat-error>
        Invalid pattern for account ID, must be 12 digits long
      </mat-error>
    }
  }
  <fieldset class="wbce">
    <legend>Region</legend>
    <mat-select [value]="data.region" formControlName="region" placeholder="Ex. : eu-west-3">
      @for (region of regions; track region) {
        <mat-option [value]="region.code">
          {{ region.name }}
        </mat-option>
      }
    </mat-select>
  </fieldset>
</form>
